export default function (context) {
  return context.redirect(`https://app2.thefutures.io`)
}
